import * as React from 'react';

const ReplyIcon = ({ height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 82"
    fill="none"
  >
    <g clipPath="url(#clip0_5342_70786)">
      <path
        d="M2.625 70L21.375 70"
        stroke="#717171"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.625 78.75L21.375 70L12.625 61.25"
        stroke="#717171"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <line
      x1="2.2291"
      y1="70"
      x2="2.2291"
      y2="-0.000816345"
      stroke="#717171"
      strokeWidth="1.2"
    />
    <defs>
      <clipPath id="clip0_5342_70786">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(22 60) rotate(90)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default ReplyIcon;
